"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TextField = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _FormControl = require("./FormControl");

var _InputLabel = require("./InputLabel");

var _Input = require("./Input");

var _Select = require("./Select");

var _FormHelperText = require("./FormHelperText");

var _FormFeedbackText = require("./FormFeedbackText");

var _core = require("@emotion/core");

var propTypes = process.env.NODE_ENV !== "production" ? {
  InputProps: _propTypes.any,
  FormHelperTextProps: _propTypes.any,
  InputLabelProps: _propTypes.any,
  labelRef: _propTypes.any,
  inputRef: _propTypes.any,
  type: _propTypes.string,
  id: _propTypes.string,
  name: _propTypes.string,
  label: _propTypes.string,
  helperText: _propTypes.string,
  feedbackText: _propTypes.string,
  value: _propTypes.any,
  defaultValue: _propTypes.any,
  placeholder: _propTypes.any,
  onChange: _propTypes.func,
  error: _propTypes.bool,
  success: _propTypes.bool,
  search: _propTypes.bool,
  isLoading: _propTypes.bool,
  warning: _propTypes.bool,
  disabled: _propTypes.any,
  select: _propTypes.bool,
  multiple: _propTypes.bool,
  children: _propTypes.node,
  onBlur: _propTypes.func
} : {};
var defaultProps = {
  select: false,
  multiple: false,
  onBlur: function onBlur() {
    return null;
  }
};

var TextField = function TextField(_ref) {
  var InputProps = _ref.InputProps,
      FormHelperTextProps = _ref.FormHelperTextProps,
      InputLabelProps = _ref.InputLabelProps,
      labelRef = _ref.labelRef,
      inputRef = _ref.inputRef,
      type = _ref.type,
      id = _ref.id,
      name = _ref.name,
      label = _ref.label,
      helperText = _ref.helperText,
      feedbackText = _ref.feedbackText,
      value = _ref.value,
      defaultValue = _ref.defaultValue,
      placeholder = _ref.placeholder,
      onChange = _ref.onChange,
      error = _ref.error,
      success = _ref.success,
      warning = _ref.warning,
      isLoading = _ref.isLoading,
      search = _ref.search,
      disabled = _ref.disabled,
      select = _ref.select,
      multiple = _ref.multiple,
      children = _ref.children,
      onBlur = _ref.onBlur;
  var helperTextId = helperText && id ? "".concat(id, "-helper-text") : undefined;
  var feedbackTextId = feedbackText && id ? "".concat(id, "-feedback-text") : undefined;
  return (0, _core.jsx)(_FormControl.FormControl, {
    success: success,
    warning: warning,
    disabled: disabled,
    error: error
  }, label && (0, _core.jsx)(_InputLabel.InputLabel, (0, _extends2.default)({
    htmlFor: id,
    ref: labelRef
  }, InputLabelProps), label), helperText && (0, _core.jsx)(_FormHelperText.FormHelperText, (0, _extends2.default)({
    id: helperTextId
  }, FormHelperTextProps), helperText), select ? (0, _core.jsx)(_Select.Select, (0, _extends2.default)({
    id: id,
    name: name,
    "aria-describedby": helperTextId,
    value: value,
    defaultValue: defaultValue,
    inputRef: inputRef,
    placeholder: placeholder,
    onChange: onChange,
    success: success,
    warning: warning,
    disabled: disabled,
    error: error,
    isLoading: isLoading,
    multiple: multiple,
    children: children
  }, InputProps)) : (0, _core.jsx)(_Input.Input, (0, _extends2.default)({
    type: type,
    id: id,
    name: name,
    "aria-describedby": helperTextId,
    value: value,
    defaultValue: defaultValue,
    inputRef: inputRef,
    placeholder: placeholder,
    onChange: onChange,
    onBlur: onBlur,
    success: success,
    warning: warning,
    disabled: disabled,
    error: error,
    isLoading: isLoading,
    search: search
  }, InputProps)), feedbackText && (0, _core.jsx)(_FormFeedbackText.FormFeedbackText, (0, _extends2.default)({
    id: feedbackTextId
  }, FormHelperTextProps, {
    success: success,
    warning: warning,
    error: error
  }), feedbackText));
};

exports.TextField = TextField;
process.env.NODE_ENV !== "production" ? TextField.propTypes = propTypes : void 0;
TextField.defaultProps = defaultProps;